// extracted by mini-css-extract-plugin
module.exports = {"familyPointsTitle":"FamilyPointsField_familyPointsTitle__mNpXa","field":"FamilyPointsField_field__iJOYG","inputField":"FamilyPointsField_inputField__3s2HN"};